import React, { useContext, useEffect, useState } from "react";
import "./OffcanvasMenu.css";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../../Contexts/AuthContext/AuthProvider";
import axios from "axios";
const OffcanvasMenu = ({ handleClose }) => {
  const { authUser } = useContext(AuthContext);

  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(
        `https://api.wlfmobile.com/api/admin/site/setting/social/support/view`
      )
      .then((res) => {
        setData(res?.data?.data);
      })
      .catch((err) => {
        // console.log("API call error:", err?.message);
      });
  }, []);

  return (
    <>
      <section className="offcanvas-menu-section">
        <nav
          className="menu js-menu open"
          aria-label="Sidebar"
          aria-hidden="true"
        >
          <div className="container-fluid mt-lg-160 mega-menu-container">
            <div className="row">
              <div className="mega-menu-content col-12 col-lg-9">
                <div id="menu3" className="row menu-board menu-board-active">
                  <div className="col-12 col-lg-3 mb-3 mt-4 mt-lg-0">
                    <ul
                      className="menu-board-list"
                      role="menu"
                      aria-label="Secondary"
                    >
                      <li role="none">
                        <h3 className="mb-3 mb-lg-3">
                          <Link
                            className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                            role="menuitem"
                            to="/login"
                            aria-label="About Us"
                            style={{ marginLeft: "auto" }}
                            onClick={handleClose}
                          >
                            Sign In - Sign Up
                          </Link>
                        </h3>
                      </li>
                      <li role="none">
                        <h3 className="mb-3 mb-lg-3">
                          <Link
                            className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                            role="menuitem"
                            to="news"
                            aria-label="News"
                            style={{ marginLeft: "auto" }}
                            onClick={handleClose}
                          >
                            News
                          </Link>
                        </h3>
                      </li>
                      <li role="none">
                        <h3 className="mb-3 mb-lg-3">
                          <a
                            className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                            role="menuitem"
                            href={`mailto:${data?.email}`}
                            aria-label="About Us"
                            style={{ marginLeft: "auto" }}
                            onClick={handleClose}
                          >
                            Contact Us
                          </a>
                        </h3>
                      </li>


                      <li role="none">
                        <h3 className="mb-3 mb-lg-3">
                          <Link
                            className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                            role="menuitem"
                            to="/platform/apps"
                            aria-label="About Us"
                            style={{ marginLeft: "auto" }}
                            onClick={handleClose}
                          >
                            Platform Apps
                          </Link>
                        </h3>
                      </li>


                      <li role="none">
                        <h3 className="mb-3 mb-lg-3">
                          <Link
                            className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                            role="menuitem"
                            to="/about/us"
                            aria-label="About Us"
                            style={{ marginLeft: "auto" }}
                            onClick={handleClose}
                          >
                            About Us
                          </Link>
                        </h3>
                      </li>


                      <li role="none">
                        <h3 className="mb-3 mb-lg-3">
                          <Link
                            className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                            role="menuitem"
                            to="/who-we-are/our-purpose"
                            aria-label="About Us"
                            style={{ marginLeft: "auto" }}
                            onClick={handleClose}
                          >
                            Our Purpose
                          </Link>
                        </h3>
                      </li>


                      <li role="none">
                        <h3 className="mb-3 mb-lg-3">
                          <Link
                            className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                            role="menuitem"
                            to="/privacy/policy"
                            aria-label="About Us"
                            style={{ marginLeft: "auto" }}
                            onClick={handleClose}
                          >
                            Privacy Policy
                          </Link>
                        </h3>
                      </li>


                      <li role="none">
                        <h3 className="mb-3 mb-lg-3">
                          <Link
                            className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                            role="menuitem"
                            to="/who-we-are/sustainability-data--trading-insights3"
                            aria-label="About Us"
                            style={{ marginLeft: "auto" }}
                            onClick={handleClose}
                          >
                            Sustainability Data & Trading Insights
                          </Link>
                        </h3>
                      </li>


                    </ul>
                  </div>
                  {/* <div className="col-12 col-lg-3 mb-3">
                    <ul
                      className="menu-board-list"
                      role="menu"
                      aria-label="Secondary"
                    >
                      <li role="none">
                        <h3 className="mb-3 mb-lg-3">
                          {authUser?._id ? (
                            <Link
                              className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                              role="menuitem"
                              to="/user/dashboard"
                              aria-label="Login"
                              style={{ marginLeft: "auto" }}
                              onClick={handleClose}
                            >
                              Dashboard
                            </Link>
                          ) : (
                            <Link
                              className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                              role="menuitem"
                              to="/login"
                              aria-label="Login"
                              style={{ marginLeft: "auto" }}
                              onClick={handleClose}
                            >
                               Sign In - Sign Up
                            </Link>
                          )}
                        </h3>
                      </li>
                     
                      <li role="none">
                        <h3 className="mb-3 mb-lg-3">
                          <a
                            className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                            role="menuitem"
                            href={`mailto:${data?.email}`}
                            aria-label="Contact Us"
                            style={{ marginLeft: "auto" }}
                          >
                            Contact Us
                          </a>
                        </h3>
                      </li>

                      <li role="none">
                        <h3 className="mb-3 mb-lg-3">
                          <Link
                            className="menu-title col-xs-6 display-size-8 display-size-10-sm font-slatepro d-block lh-1_2"
                            role="menuitem"
                            to="/platform/apps"
                            aria-label="Careers"
                            style={{ marginLeft: "auto" }}
                            onClick={handleClose}
                          >
                            Download Apps
                          </Link>
                        </h3>
                      </li>

                    </ul>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </nav>
      </section>
    </>
  );
};

export default OffcanvasMenu;
